import React from 'react';
import { Box, Button } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const TransportFormElement = ({ name, control }) => {
  const { t } = useTranslation();
  const transportButtons = [
    {
      label: t('car'),
      value: 'car',
      titleHover: t('Car'),
    },
    {
      label: t('Bike'),
      value: 'bike',
      titleHover: t('Bike'),
    },
    {
      label: t('P.T'),
      value: 'publicTransport',
      titleHover: t('Pubic Transport'),
    },
  ];
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <Box display="flex" gap="10px" flexWrap={'wrap'}>
          {transportButtons.map((btn) => {
            const isActive = btn.value === value;
            console.log(isActive, `btn.value: ${btn.value}, value: ${value}`);
            return (
              <Button
                key={btn.value}
                sx={(theme) => ({
                  padding: '12px 24px',
                  outline: isActive ? `1px solid ${theme.palette.secondary.main}` : '1px solid #DCE4E8',
                  borderRadius: '14px',
                  color: isActive ? '#fff' : 'rgb(0,0,0)',
                  lineHeight: 1,
                  backgroundColor: isActive ? theme.palette.secondary.main : '#fff',
                  '&:hover': {
                    color: '#fff',
                    backgroundColor: theme.palette.secondary.main + 'CC',
                    outline: isActive ? `1px solid ${theme.palette.secondary.main}` : '1px solid #DCE4E8',
                  },
                })}
                title={btn.titleHover}
                onClick={() => onChange(btn.value)}
              >
                {btn.label}
              </Button>
            );
          })}
        </Box>
      )}
    />
  );
};

export default TransportFormElement;
